import config from './config.eli';

export default config;
